<mat-table [dataSource]="angularMatData" matSort matSortDisableClear matSortActive="Date" matSortDirection="desc"
    style="width: 100%" aria-label="Fee Payment Details Table" tabindex="-1">
    <ng-container matColumnDef="Date">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width: 150px;"><span translate>Date</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:150px;max-width: 150px;">{{detail.Date|date:'MM/dd/yy'}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Description">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;"><span translate>Description</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:150px;">{{detail.Description}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Type">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;padding-left: 10px;"><span translate>Type</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:100px;max-width:150px;padding-left: 10px;">{{detail.Type}}</mat-cell>
    </ng-container>
    <ng-container matColumnDef="Fee">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;"><span translate>Fee</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:100px;max-width:150px;">
            <span style="text-align:right;width:100%;" [ngStyle]="{'color' : detail.Fee == 0 ? '#939393' : 'black'}">{{detail.Fee != '' && detail.Fee != null && detail.Fee > 0 ? (detail.Fee|number:'1.2-2') : (detail.Fee != '' && detail.Fee != null ? (detail.Fee*-1|number:'1.2-2') : '')}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Payment">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:100px;max-width:150px;"><span translate>Payment</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:100px;max-width:150px;">
            <span style="text-align:right;width:100%;" [ngStyle]="{'color' : detail.Payment == 0 ? '#939393' : 'black'}">{{detail.Payment != '' && detail.Payment != null && detail.Payment > 0 ? (detail.Payment|number:'1.2-2') : (detail.Payment != '' && detail.Payment != null ? (detail.Payment*-1|number:'1.2-2') : '')}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="RunningBalance">
        <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:150px;max-width:200px;"><span translate>Balance</span></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:150px;max-width:200px;">
            <span style="text-align:right;width:100%;" [ngStyle]="{'color' : detail.RunningBalance == 0 ? '#939393' : 'black'}">{{detail.RunningBalance != '' && detail.RunningBalance != null && detail.RunningBalance > 0 ? (detail.RunningBalance|number:'1.2-2') : (detail.RunningBalance != '' && detail.RunningBalance != null ? (detail.RunningBalance*-1|number:'1.2-2') : '')}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="BalanceType">
        <mat-header-cell *matHeaderCellDef style="min-width:100px;max-width:100px;"></mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:100px;max-width:100px;">            
            <span style="text-align:left;width:100%;">{{detail.RunningBalance > 0 ? '&nbsp;Credit' : (detail.RunningBalance < 0 ? '&nbsp;Due' : '')}}</span>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Details">
        <mat-header-cell *matHeaderCellDef style="min-width:100px;max-width:150px;" translate>Additional Details</mat-header-cell>
        <mat-cell *matCellDef="let detail" style="min-width:100px;max-width:150px;">
            <span style="text-align:center;width:100%;" *ngIf="hideDetails(detail)">&nbsp;&nbsp;<a class="link" (click)="showDialog(detail)" translate>Details</a></span>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="columnsToDisplay" tabindex="-1">
    </mat-header-row>
    <mat-row *matRowDef="let row; let i = index; columns: columnsToDisplay" tabindex="0" [attr.aria-label]="getAriaDetailRowByDate(row)">
    </mat-row>
</mat-table>



